import { ServiceBase } from "@app/shared";
import { SortDirections } from "../shared/waffles";
import { RoleAssignmentListModel, RoleModel } from "@app/user";
import { authenticatedDownloadAsync } from "../shared/AuthenticatedDownload";
import moment from "moment";
import { querystringify } from "@app/shared/utility";

/** Manages the retrieval and manipulation of user information. */
export default class RoleService extends ServiceBase {

  public async getRoleAssignments(skip: number, take: number, clientNameFilter: string, userNameFilter: string, includeQuestAdmins: boolean, includeQuestUsers: boolean, includeClientUsers: boolean, includeRoleList: boolean, roleIdList: number[], clientId?: number, sortDirection?: SortDirections, sortedColumn?: string): Promise<RoleAssignmentListModel> {
    const sortDirectionEnumValue = sortDirection === SortDirections.Asc ? 3 : sortDirection === SortDirections.Desc ? 2 : 1;
    const query = {
      clientId,
      clientNameFilter,
      includeClientUsers,
      includeQuestAdmins,
      includeQuestUsers,
      includeRoleList,
      offset: skip,
      pageSize: take,
      roleIdList,
      sortDirection: sortDirectionEnumValue,
      sortedColumn,
      userNameFilter,
    };

    return await this.makeGet(`/roles/role-assignments?${querystringify(query)}`);
  }

  public async getAllRoles(): Promise<RoleModel[]> {
    return await this.makeGet(`/roles`);
  }

  public async getRoleAssignmentsCsv(clientNameFilter: string, userNameFilter: string, includeQuestAdmins: boolean, includeQuestUsers: boolean, includeClientUsers: boolean, includeRoleList: boolean, roleIdList: number[], clientId?: number, sortDirection?: SortDirections, sortedColumn?: string): Promise<void> {
    const sortDirectionEnumValue = sortDirection === SortDirections.Asc ? 3 : sortDirection === SortDirections.Desc ? 2 : 1;
    const query = {
      clientId,
      clientNameFilter,
      includeClientUsers,
      includeQuestAdmins,
      includeQuestUsers,
      includeRoleList,
      roleIdList,
      sortDirection: sortDirectionEnumValue.toString(),
      sortedColumn,
      userNameFilter,
    };

    return await authenticatedDownloadAsync(`${window.apiEndpointV2_0}/roles/role-assignments/csv`, null, `RoleAssignments_${moment.utc().local().format("yyyyMMDD_hhmmss")}`, new URLSearchParams(querystringify(query)));
  }
}
